import 'bootstrap/dist/css/bootstrap.css';
import './app.css'

import { Form, FormTerms, Home, Login } from './../Pages';
import { Route, Router } from 'react-router-dom';
import { faArrowRight, faCheck, faChevronUp, faDownload, faEye, faEyeSlash, faSave, faShare, faSpinner, faTrashAlt } from '@fortawesome/free-solid-svg-icons'

import { PrivateRoute } from './../Components';
import React from 'react';
import { history } from './../Helpers';
import { library } from '@fortawesome/fontawesome-svg-core'

const App = () => {
    library.add(faArrowRight, faCheck, faChevronUp, faDownload, faEye, faEyeSlash, faSave, faShare, faSpinner, faTrashAlt);

    return (     
        <Router history={history}>
            <Route path="/q/:ea/:clientKey?/:recipientEmail?/:formId?" component={Form} />            
            <PrivateRoute exact path="/" component={Home} />                    
            {/* <Route path="/about" component={About} />                     */}
            <PrivateRoute path="/:clientKey/:recipientEmail/forms/:key/:number/:action?" component={Form} />                
            <PrivateRoute path="/:clientKey/templates/:key" component={Form} />                
            <PrivateRoute path="/:clientKey/terms/:termId" component={FormTerms} />                
            <PrivateRoute path="/:clientKey/forms/:formKey/terms/:termId" component={FormTerms} />                
            {/* <Route path="/terms" component={Terms} /> */}                    
            <Route path="/login/:email?" component={Login} />                        
        </Router>
    );
}

export default App;
